/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Daily_Complete_Short_LabelInputs */

const bn_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দৈনিক`)
};

const de_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglich`)
};

const el_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καθημερινά`)
};

const en_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily`)
};

const es_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diario`)
};

const fr_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quotidien`)
};

const hi_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दैनिक`)
};

const hu_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napi`)
};

const id_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehari-hari`)
};

const it_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quotidiano`)
};

const ja_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日`)
};

const ko_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일`)
};

const nl_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks`)
};

const pl_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codziennie`)
};

const pt_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diário`)
};

const ru_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневно`)
};

const sv_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagligen`)
};

const tr_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük`)
};

const uk_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щодня`)
};

const vi_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hằng ngày`)
};

const zh_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常的`)
};

const zh_hant_game_daily_complete_short_label = /** @type {(inputs: Game_Daily_Complete_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常的`)
};

/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Game_Daily_Complete_Short_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_daily_complete_short_label = /** @type {((inputs?: Game_Daily_Complete_Short_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Daily_Complete_Short_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_daily_complete_short_label(inputs)
	if (locale === "de") return de_game_daily_complete_short_label(inputs)
	if (locale === "el") return el_game_daily_complete_short_label(inputs)
	if (locale === "en") return en_game_daily_complete_short_label(inputs)
	if (locale === "es") return es_game_daily_complete_short_label(inputs)
	if (locale === "fr") return fr_game_daily_complete_short_label(inputs)
	if (locale === "hi") return hi_game_daily_complete_short_label(inputs)
	if (locale === "hu") return hu_game_daily_complete_short_label(inputs)
	if (locale === "id") return id_game_daily_complete_short_label(inputs)
	if (locale === "it") return it_game_daily_complete_short_label(inputs)
	if (locale === "ja") return ja_game_daily_complete_short_label(inputs)
	if (locale === "ko") return ko_game_daily_complete_short_label(inputs)
	if (locale === "nl") return nl_game_daily_complete_short_label(inputs)
	if (locale === "pl") return pl_game_daily_complete_short_label(inputs)
	if (locale === "pt") return pt_game_daily_complete_short_label(inputs)
	if (locale === "ru") return ru_game_daily_complete_short_label(inputs)
	if (locale === "sv") return sv_game_daily_complete_short_label(inputs)
	if (locale === "tr") return tr_game_daily_complete_short_label(inputs)
	if (locale === "uk") return uk_game_daily_complete_short_label(inputs)
	if (locale === "vi") return vi_game_daily_complete_short_label(inputs)
	if (locale === "zh") return zh_game_daily_complete_short_label(inputs)
	return zh_hant_game_daily_complete_short_label(inputs)
});